<template>
	<div class="msg-quote" v-if="hasQuote">
		<div class="msg-quote-wrap">
			<div class="msg-quote-msg" v-html="quoteMsg.name + '：' + quoteMsg.content"></div>
			<div class="msg-quote-ohter" v-if="quoteMsg.type === 'image'">
				<img :src="quoteMsg.other.showUrl" alt="">
			</div>
			<div class="msg-quote-ohter" v-else-if="quoteMsg.type === 'video'">
				<video width="40" height="">
					<source :src="quoteMsg.other.showUrl"  type="video/mp4"></source>
				</video>
			</div>
			<div class="msg-quote-ohter" v-if="quoteMsg.type === 'program'">
				<img :src="quoteMsg.other.showUrl" alt="">
			</div>
			<div class="msg-quote-ohter" v-if="quoteMsg.type === 'link'">
				<img :src="quoteMsg.other.showUrl" alt="">
			</div>
		</div>
	</div>
</template>

<script>
	import {getChatRecordByCidAndMsgid} from '../../network/local/chat-record.js'
	
	export default{
		name: 'MsgQuote',
		components:{
			
		},
		props:{
			msg:{
				  type:Object,
				  default:function(){
					  return {}
				  }
			}
		},
		data(){
			return {
				quoteMsg: {
					type: 'text',
					name: '--',
					content: '--',
					other: {
						
					}
				},
				hasQuote: false
			}
		},
		
		methods:{
			handleMsg(data){
				if(data.id !== undefined){
					this.hasQuote = true
					this.quoteMsg.name = data.from_name
					// 处理消息基础内容，文本展示模块
					let content = ''
					let other = {}
					this.quoteMsg.type = data.type
					switch(data.type){
						case 'text':
							content = data.content
							break
						case 'image':
							other.showUrl = data.content
							break
						case 'video':
							other.showUrl = data.content
							break
						case 'program':
							try{
								let obj = JSON.parse(data.content)
								content = '<span style="color:#06b990">【小程序】</span>'+obj.title
								other.showUrl = obj.iconUrl
							}catch(e){
								//TODO handle the exception
							}
							break
						case 'link':
							try{
								let obj = JSON.parse(data.content)
								content = '<span style="color:#06b990">【链接】</span>'+obj.link_title
								other.showUrl = '/img/link-big-8a.png'
							}catch(e){
								//TODO handle the exception
							}
							break
						default:
							content = '其他引用暂不支持，请在手机端查看！'
					}
					this.quoteMsg.content = content
					this.quoteMsg.other = other
				}
			}
		},
		
		created() {
			let __this = this
			if(this.msg.custom_id !== undefined && this.msg.other !== undefined && this.msg.other !== null){
				try{
					let ohter = JSON.parse(this.msg.other)
					if(ohter.quoteId !== undefined){
						getChatRecordByCidAndMsgid(this.msg.custom_id,ohter.quoteId,data=>{
							__this.handleMsg(data)
						})
					}
				}catch(e){
					//TODO handle the exception
				}
			}
		}
	}
</script>

<style>
	.msg-quote{
		font-size: 12px;
		color: #666666;
		display: flex;
	}
	.msg-quote-wrap{
		display: flex;
		justify-content: flex-start;
		align-items: center;
		padding: 3px 10px;
		margin-top: 3px;
		background-color: #EEEEEE;
		border-radius: 2px;
	}
	.msg-quote-msg{
		max-width: 200px;
		max-height: 40px;
		line-height: 20px;
		overflow: hidden;
	}
	.msg-quote-ohter{
		margin-left: 10px;
	}
	.msg-quote-ohter img{
		width: 40px;
		height: 40px;
		border-radius: 2px;
	}
</style>
